export const maxDecimals = 256;
export const maxPlatformDecimals = 6;
